import { FC, useContext, useEffect, useState } from 'react';
import { ProposalData } from 'ts/shared/interfaces/ProposalData';
import { dateFormat } from 'utils/shared/utils';
import { useTranslation } from 'react-i18next';
import SingleProposalBody from './SingleProposalBody';
import { MainContext } from 'contexts/MainContext';

interface SingleProposalProps {
  proposal: ProposalData;
  template: string;
  isProposalsPage?: boolean;
  onEdit?: () => void;
  sort: string;
}

const SingleProposal: FC<SingleProposalProps> = ({
  proposal,
  template,
  sort,
}) => {
  const { t, i18n } = useTranslation();
  const [userString, setUserString] = useState<string>();
  const [logoUrl, setLogoUrl] = useState<string>();
  const { cdnUrl } = useContext(MainContext);

  useEffect(() => {
    if (proposal.externalParam_1) {
      const params = JSON.parse(proposal.externalParam_1);

      if (params.user?.userFullName || params.user?.userEmail) {
        setUserString(
          [
            params.user?.userFullName + ' - ' + params.user?.branchDescription,
            params.user?.userEmail,
            params.user?.userPhone,
          ]
            .filter((param) => param)
            .join(', ')
        );

        const logo =
          cdnUrl +
          '/backend/nocache/prod.beprotravel/cdn/logo/' +
          params?.branchLogo +
          '?v=' +
          new Date().getTime();
        setLogoUrl(logo);
      }
    }
  }, [proposal, cdnUrl]);

  return (
    <div className="pr-single">
      <div id="pr-header">
        <div
          className={'flex-between pr-header-content bb-1' + (i18n.language === 'he' ? ' rtl' : '')}
        >
          <div className="pr-header-content-logo">
            <img src={logoUrl} alt="logo" />
          </div>
          <div className="text-bold pr-header-content-title">
            {t('proposal.proposal')} #{proposal.id}
          </div>
          <div className="text-sm pr-header-content-date text-nowrap">
            {t('proposal.created_at')}: {dateFormat(proposal.dateC, 'dd MMM, yyyy HH:mm', 'en')}
          </div>
        </div>
      </div>

      <SingleProposalBody proposal={proposal} template={template} sort={sort} />

      <div id="pr-footer">
        <div className={'form-control' + (i18n.language === 'he' ? ' rtl' : '')}>
          <div>{userString}</div>
        </div>
      </div>
    </div>
  );
};

export default SingleProposal;
